export default __webpack_public_path__ + "static/media/replied.bf75e507.svg";